import styled from 'styled-components'

export const Heading4 = styled.h4``
